import type { FindingsReport } from '../../lib/api.ts'
import type { CheckCell } from '../../lib/findingsList.ts'
import { FindingsFlow } from './FindingsFlow.tsx'

export function FindingsPath({
  report,
  selected,
  onExplore = () => {},
}: {
  report: FindingsReport
  selected?: CheckCell | undefined
  onExplore?: (cell: CheckCell) => void
}) {
  return <FindingsFlow report={report} selected={selected} onExplore={onExplore} />
}
